module.exports = __webpack_public_path__ + "img/my_location.34dab845.png";